//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import ErrorDisplay from '../../../../common/ErrorDisplay.vue';
import MemberEmail from '../../profile/form/MemberEmail';
import MemberPassword from '../../profile/form/MemberPassword';
import Logo from '../../../../common/svg/Logo.vue';

export default {
  name: 'UltraSignup',
  components: {
    ErrorDisplay,
    Logo,
    MemberEmail,
    MemberPassword,
  },

  created() {
    this.pageTitle = 'Landing Page';
    this.description = 'Description';
    this.instructionsTitle = '2 Steps to Join';
  },

  data() {
    return {
      pageTitle: '',
      pageState: '',
      description: '',
      instructionsTitle: '',
      teamId: '1b3a146b-3607-4232-9098-b99e643c63f0',
      loading: false,
      email: '',
      password: '',
      error: null,
    };
  },

  methods: {
    ...mapActions(['register']),

    async createAccount() {
      this.pageState = 'Creating account...';
      this.loading = true;
      this.error = null;
      try {
        await this.register({ email: this.email, password: this.password, coupon: this.$route.meta.couponCode });
        this.pageState = 'Loading Data...';

        await this.$store.dispatch('loadData');

        this.pageState = 'Success!';
        this.$container.analytics.trackRegistration(this.$store.state.user.memberId);

        this.$router.push({ name: 'setup' });
      } catch (error) {
        this.errorDisplayMessage = 'Unable to create account';
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    handleError(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.loading = false;
    },

    launch(from) {
      this.$refs[from][0].launch();
    },
  },
};
